export default "__VITE_ASSET__5394d538__"